import { useEffect } from "react";
import CardTestimoMarcas from "./CardTestimoMarcas";
import CardTestimoClientes from "./CardTestimoClientes";
import CardClientes from "./cardClientes";

import useStore from "../store/useStore";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

export default function CarouselTestimonios() {
  //   const testimoniosData = [
  //     {
  //       type: "testimonio",
  //       name: "Agustín Berger",
  //       title: "Líder de Proyectos de IT",
  //       rating: 5,
  //       desc: "La plataforma de comercio exterior SIDOM GT optimizó procesos de importación complejos en Argentina, y facilitó la regionalización en Chile, Paraguay, Bolivia y Uruguay. Esto permitió constituir un Shared Service Center desde Argentina para todo el Cono Sur.",
  //       image:
  //         "https://sidomsuite.com/wp-content/uploads/2024/09/JHONSONCONTROLS-Carolina-Galda.jpg",
  //     },
  //     {
  //       type: "testimoniomarcas",
  //       title: "Joaquín Banic",
  //       title2: "Chief Methodologies & Processes",
  //       description:
  //         "Desde el primer día notamos la excelente predisposición y escucha activa del equipo de SIDOM, entendiendo con claridad nuestras necesidades y objetivos.",
  //       buttonText: "Ver más",
  //     },
  //     {
  //       type: "testimoniouser",
  //       name: "Pedro",
  //       title: "Chief Methodologies & Processes",
  //       rating: 4,
  //       desc: "El respeto y la respuesta inmediata ante consultas sobre SIDOM nos permite avanzar constantemente en nuestros objetivos.",
  //       image:
  //         "https://sidomsuite.com/wp-content/uploads/2024/09/JHONSONCONTROLS-Carolina-Galda.jpg",
  //     },
  //     {
  //       type: "testimonio",
  //       name: "Laura Martínez",
  //       title: "Directora de Operaciones",
  //       rating: 5,
  //       desc: "SIDOM transformó completamente nuestra gestión logística, permitiéndonos reducir tiempos y costos de manera significativa.",
  //       image:
  //         "https://sidomsuite.com/wp-content/uploads/2024/09/JHONSONCONTROLS-Carolina-Galda.jpg",
  //     },
  //     {
  //       type: "testimoniomarcas",
  //       title: "Empresa XYZ",
  //       title2: "Líder en el sector",
  //       description:
  //         "Hemos experimentado un aumento del 30% en eficiencia desde que implementamos SIDOM. La herramienta se adaptó rápidamente a nuestros procesos.",
  //       buttonText: "Conocer caso",
  //     },
  //     {
  //       type: "testimoniouser",
  //       name: "Carlos Rodríguez",
  //       title: "Usuario Premium",
  //       rating: 4,
  //       desc: "La interfaz intuitiva y el soporte técnico inmediato hacen que SIDOM sea una herramienta indispensable en mi día a día.",
  //       image:
  //         "https://sidomsuite.com/wp-content/uploads/2024/09/JHONSONCONTROLS-Carolina-Galda.jpg",
  //     },
  //   ];
  // const testimoniosMock = [
  //   {
  //     id: 8,
  //     documentId: "au4rlratpjog6aansxbu28p1",
  //     nombre: "Agustín Berger",
  //     cargo: "Líder de Proyectos de IT",
  //     estrellas: 5,
  //     Tipo: "Testimonio",
  //     comentario:
  //       "La plataforma de comercio exterior SIDOM GT optimizó procesos de importación complejos en Argentina, y facilitó la regionalización en Chile, Paraguay, Bolivia y Uruguay. Esto permitió constituir un Shared Service Center desde Argentina para todo el Cono Sur.",
  //   },
  //   {
  //     id: 11,
  //     documentId: "dac69j4u9oofeenbpoaid3e9",
  //     nombre: "Joaquín Banic",
  //     cargo: "Líder de Proyectos de IT",
  //     comentario:
  //       "La plataforma de comercio exterior SIDOM GT optimizó procesos de importación complejos en Argentina, y facilitó la regionalización en Chile, Paraguay, Bolivia y Uruguay. Esto permitió constituir un Shared Service Center desde Argentina para todo el Cono Sur.",
  //     Tipo: "Testimonio",
  //   },
  //   {
  //     id: 14,
  //     documentId: "qykdvsoge8bx820yi3p21cog",
  //     nombre: "Pedro  Banic",
  //     cargo: "Chief Methodologies & Processes",
  //     comentario:
  //       "El proceso del cálculo de las descargas RAF en menos de 10 minutos por embarque.",
  //     Tipo: "testimoniouser",
  //   },
  //   {
  //     id: 18,
  //     documentId: "n0wy8cpclc9ehmwh9hrtjg4n",
  //     empresa: "TOYOTA Argentina",
  //     titulo: "80% Reducción del tiempo RAF",
  //     comentario:
  //       "El proceso del cálculo  de las  descargas RAF en menos de 10 minutos por embarque.",
  //     Tipo: "Testimoniomarcas",
  //   },
  //   {
  //     id: 16,
  //     documentId: "oc84y6bzwaw30dbw93d1eoin",
  //     empresa: "Honda Argentina",
  //     titulo: "80% Reducción del tiempo RAF",
  //     comentario:
  //       "El proceso del cálculo  de las  descargas RAF en menos de 10 minutos por embarque.",
  //     Tipo: "Testimoniomarcas",
  //   },
  //   {
  //     id: 13,
  //     documentId: "dj93apsrcpxrvyg2a7t7bx3w",
  //     nombre: "Pedro  Banic",
  //     cargo: "Chief Methodologies & Processes",
  //     comentario:
  //       "El proceso del cálculo de las descargas RAF en menos de 10 minutos por embarque.",
  //     Tipo: "testimoniouser",
  //   },
  //   {
  //     id: 12,
  //     documentId: "tkgr34ocn3mvfzwovq9b0td1",
  //     nombre: "Joaquín Banic",
  //     cargo: "Líder de Proyectos de IT",
  //     comentario:
  //       "La plataforma de comercio exterior SIDOM GT optimizó procesos de importación complejos en Argentina, y facilitó la regionalización en Chile, Paraguay, Bolivia y Uruguay. Esto permitió constituir un Shared Service Center desde Argentina para todo el Cono Sur.",
  //     Tipo: "Testimonio",
  //   },
  //   {
  //     id: 9,
  //     documentId: "xo3rhg9cl391uwh9rm6mz6yu",
  //     nombre: "Agustín Berger",
  //     cargo: "Líder de Proyectos de IT",
  //     estrellas: 4,
  //     comentario:
  //       "La plataforma de comercio exterior SIDOM GT optimizó procesos de importación complejos en Argentina, y facilitó la regionalización en Chile, Paraguay, Bolivia y Uruguay. Esto permitió constituir un Shared Service Center desde Argentina para todo el Cono Sur.",
  //     Tipo: "Testimonio",
  //   },
  //   {
  //     id: 17,
  //     documentId: "mg8invjvli4bnmsjbapgl9n8",
  //     empresa: "TOYOTA Argentina",
  //     titulo: "80% Reducción del tiempo RAF",
  //     comentario:
  //       "El proceso del cálculo  de las  descargas RAF en menos de 10 minutos por embarque.",
  //     Tipo: "Testimoniomarcas",
  //   },
  //   {
  //     id: 10,
  //     documentId: "nrdadd8233y89p71yfb8yzc6",
  //     nombre: "Joaquín Banic",
  //     cargo: "Chief Methodologies & Processes",
  //     estrellas: 5,
  //     comentario:
  //       "La plataforma de comercio exterior SIDOM GT optimizó procesos de importación complejos en Argentina, y facilitó la regionalización en Chile, Paraguay, Bolivia y Uruguay. Esto permitió constituir un Shared Service Center desde Argentina para todo el Cono Sur.",
  //     Tipo: "Testimonio",
  //   },
  //   {
  //     id: 19,
  //     documentId: "zb85jy6gzl8csk3or4t3fi4s",
  //     empresa: "TOYOTA Argentina",
  //     titulo: "80% Reducción del tiempo RAF",
  //     comentario:
  //       "El proceso del cálculo  de las  descargas RAF en menos de 10 minutos por embarque.",
  //     Tipo: "Testimoniomarcas",
  //   },
  // ];
  const { testimonioMarcas, getTestimonioMarcas } = useStore();
  const { testimonioUser, getTestimonioUSer } = useStore();
  const { testimonioclientes, fetchTestimonioById } = useStore();
  useEffect(() => {
    getTestimonioMarcas();
  }, [getTestimonioMarcas]);

  useEffect(() => {
    getTestimonioUSer();
  }, [getTestimonioUSer]);

  useEffect(() => {
    fetchTestimonioById();
  }, [fetchTestimonioById]);

  const allTestimonials = [
    ...testimonioclientes,
    ...testimonioMarcas,
    ...testimonioUser,
  ];

  function shuffle(array) {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }
  const randomizedTestimonials = shuffle(allTestimonials);
  // Dividir en dos mitades SIN repeticiones
  const mitad = Math.ceil(randomizedTestimonials.length / 2);
  const primerCarrusel = randomizedTestimonials.slice(0, mitad);
  // Para el segundo carrusel, filtra los que no están en el primero (por id)
  const idsPrimerCarrusel = new Set(primerCarrusel.map((t) => t.id));
  const segundoCarrusel = randomizedTestimonials.filter(
    (t) => !idsPrimerCarrusel.has(t.id)
  );
  console.log(randomizedTestimonials);
  return (
    <div className=" mt-[100px] mb-[100px]  flex flex-col items-center justify-center ">
      <div className="container text-left  mb-[60px]">
        <h2 className="font-extrabold text-left text-4xl md:text-5xl text-sidom-orange mb-8">
          Experiencias SIDOM
        </h2>
      </div>

      <div className="w-full mb-8 container  ">
        {primerCarrusel.length > 0 && (
          <Swiper
            spaceBetween={30}
            speed={8000}
            autoplay={{
              delay: 1,
              disableOnInteraction: false,
              reverseDirection: true,
            }}
            onSwiper={(swiper) => {
              swiper.slideTo(0, 0);
            }}
            navigation={true}
            modules={[Autoplay, Pagination, Navigation]}
            breakpoints={{
              420: { slidesPerView: 1, spaceBetween: 10 },
              640: { slidesPerView: 1.2, spaceBetween: 20 },
              768: { slidesPerView: 2, spaceBetween: 20 },
              1024: { slidesPerView: 2.5, spaceBetween: 40 },
              1200: { slidesPerView: 3, spaceBetween: 30 },
              1600: { slidesPerView: 3, spaceBetween: 30 },
              2000: { slidesPerView: 3, spaceBetween: 30 },
            }}
            className="mySwiper "
          >
            {primerCarrusel
              .filter((item) => item && item.Tipo)
              .map((item, idx) => {
                const key = `${item.Tipo || "tipo"}-${item.id || idx}`;
                switch (item.Tipo) {
                  case "Testimonio":
                    return (
                      <SwiperSlide key={key}>
                        <CardClientes
                          image={item.img?.formats?.thumbnail?.url}
                          name={item.nombre}
                          title={item.cargo}
                          desc={item.comentario}
                          rating={item.estrellas}
                        />
                      </SwiperSlide>
                    );
                  case "Testimoniomarcas":
                    return (
                      <SwiperSlide key={key}>
                        <CardTestimoMarcas
                          title={item.empresa || item.title}
                          title2={item.titulo || item.title2}
                          description={item.comentario || item.description}
                          buttonText="Ver Caso Completo"
                          url={item.url || ""}
                        />
                      </SwiperSlide>
                    );
                  case "testimoniouser":
                    return (
                      <SwiperSlide key={key}>
                        <CardTestimoClientes
                          title={item.nombre}
                          title2={item.cargo}
                          description={item.comentario}
                          image={item.img?.formats?.thumbnail?.url}
                          buttonText="Ver VIDEO"
                          youtubeUrl="https://www.youtube.com/embed/J9oATQIj1Tg?si=Y9pFfs_A6eY330j1%22%20title=%22YouTube"
                        />
                      </SwiperSlide>
                    );
                  default:
                    return null;
                }
              })}
          </Swiper>
        )}
      </div>
      <div className="w-full container ">
        {segundoCarrusel.length > 0 && (
          <Swiper
            speed={8000}
            autoplay={{
              delay: 1,
              disableOnInteraction: false,
              reverseDirection: false,
            }}
            onSwiper={(swiper) => {
              swiper.slideTo(0, 0);
            }}
            navigation={true}
            modules={[Autoplay, Pagination, Navigation]}
            breakpoints={{
              420: { slidesPerView: 1, spaceBetween: 10 },
              640: { slidesPerView: 1.2, spaceBetween: 20 },
              768: { slidesPerView: 2, spaceBetween: 20 },
              1024: { slidesPerView: 2.5, spaceBetween: 40 },
              1200: { slidesPerView: 3, spaceBetween: 30 },
              1600: { slidesPerView: 3, spaceBetween: 30 },
              2000: { slidesPerView: 3, spaceBetween: 30 },
            }}
            className="mySwiper "
          >
            {segundoCarrusel
              .filter((item) => item && item.Tipo)
              .map((item, idx) => {
                const key = `${item.Tipo || "tipo"}-${item.id || idx}`;
                switch (item.Tipo) {
                  case "Testimonio":
                    return (
                      <SwiperSlide key={key}>
                        <CardClientes
                          image={item.img?.formats?.thumbnail?.url}
                          name={item.nombre}
                          title={item.cargo}
                          desc={item.comentario}
                          rating={item.estrellas}
                        />
                      </SwiperSlide>
                    );
                  case "Testimoniomarcas":
                    return (
                      <SwiperSlide key={key}>
                        <CardTestimoMarcas
                          title={item.empresa || item.title}
                          title2={item.titulo || item.title2}
                          description={item.comentario || item.description}
                          buttonText="Ver Caso Completo"
                        />
                      </SwiperSlide>
                    );
                  case "testimoniouser":
                    return (
                      <SwiperSlide key={key}>
                        <CardTestimoClientes
                          title={item.nombre}
                          title2={item.cargo}
                          description={item.comentario}
                          image={item.img?.formats?.thumbnail?.url}
                          buttonText="Ver VIDEO"
                          youtubeUrl={item.url}
                        />
                      </SwiperSlide>
                    );
                  default:
                    return null;
                }
              })}
          </Swiper>
        )}
      </div>
    </div>
  );
}
